import Cookies from 'js-cookie'
const TokenKey = 'SOFT-DECORATIONE-TOKEN'
const UserKey = 'SOFT-DECORATIONE-USER'
const LoginKey = 'SOFT-DECORATIONE-LOGIN'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function getUser () {
  return Cookies.get(UserKey) ? JSON.parse(Cookies.get(UserKey)) : ''
}

export function getLogin () {
  return Cookies.get(LoginKey) || false
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires: 30 })
}

export function setUser (user) {
  return UserKey ? Cookies.set(UserKey, JSON.stringify(user), { expires: 30 }): ''
}

export function setLogin (isLogin) {
  return Cookies.set(LoginKey, isLogin)
}

export function removeUserInfo () {
  Cookies.remove(TokenKey)
  return Cookies.remove(UserKey)
}
